import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { GlobalErrorService } from '@services/global-error.service';
import { OpenPositionsResponse } from '@interfaces/open-positions.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpsOpenPositionsService {
  private baseUrl = environment.apiUrl;
  openPositionsSignal: WritableSignal<any> = signal(null);
  private dataLoading = false;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  getOpenPositions(): Observable<OpenPositionsResponse> {
    if (!this.openPositionsSignal() && !this.dataLoading) {
      this.fetchOpenPositions();
    }
    return of(this.openPositionsSignal() || []);
  }

  private fetchOpenPositions() {
    this.dataLoading = true;
    this.http
      .get<OpenPositionsResponse>(`${this.baseUrl}/ops/open-positions`)
      .subscribe({
        next: (data) => {
          this.openPositionsSignal.set(data);
          this.dataLoading = false;
        },
        error: (error) => {
          this.errorHandler.logError(error);
          this.dataLoading = false;
        },
      });
  }
}
